<template>
	<div class="page-wrapper">
		<div class="tabs-wrapper">
			<div class="tabs-header">
				<b-tabs lazy>
						<b-tab :title="$t('globals.all_services')" active></b-tab>
				</b-tabs>
				<div class="tabs-header-actions">
					<div class="metric-badge">
            <span class="metric-label">{{ $t("globals.total") }}:</span>
            <span class="metric-value">{{ getTotalServices }}</span>
          </div>
					<button
						class="reload-btn"
						@click="reloadData"
						:disabled="getServicesLoading"
						v-b-tooltip.hover
						:title="$t('globals.reload')"
					>
						<icon name="sync-alt" :spin="getServicesLoading"></icon>
					</button>
				</div>
			</div>
			<div class="tab-content">
				<div class="tab-content-inner">
					 <div class="filters-section">
						<!-- filters-->
						<div class="filter-group">
              <div class="filter-item">
                <label class="filter-label">{{ $t("globals.order_no") }}</label>
                <b-form-input
                  v-model="filters.order_no"
                  class="search-input"
                  :placeholder="$t('globals.order_no') + '...'"
                  :disabled="getServicesLoading"
                  @input="onInput"
                />
              </div>
              <div class="filter-item">
                <label class="filter-label">{{ $t("globals.status") }}</label>
                <b-form-select
                  v-model="filters.status"
                  :options="[{ value: null, text: $t('globals.all') }, ...getStatuses.map(status => ({ value: status, text: status }))]"
                  class="filter-select"
									@change="filterChanged"
                  :disabled="getServicesLoading"
                />
              </div>
							<div class="filter-item">
                <label class="filter-label">{{ $t("globals.customer") }}</label>
                <b-form-select
                  v-model="filters.customer_id"
                  :options="[{ value: null, text: $t('globals.all') }, ...getCustomers.map(customer => ({ value: customer.id, text: customer.company_name }))]"
                  class="filter-select"
									@change="filterChanged"
                  :disabled="getServicesLoading"
                />
              </div>
							<div class="filter-item">
                <label class="filter-label">{{ $t("globals.agent") }}</label>
                <b-form-select
                  v-model="filters.agent_id"
                  :options="[{ value: null, text: $t('globals.all') }, ...getAgents.map(agent => ({ value: agent.id, text: agent.full_name }))]"
                  class="filter-select"
									@change="filterChanged"
                  :disabled="getServicesLoading"
                />
              </div>
							<div class="filter-item">
                <label class="filter-label">{{ $t("globals.service_type") }}</label>
                <b-form-select
                  v-model="filters.service_type"
                  :options="[{ value: null, text: $t('globals.all') }, ...getServiceTypes.map(type => ({ value: type, text: type }))]"
                  class="filter-select"
                  @change="filterChanged"
                  :disabled="getServicesLoading"
                />
              </div>
							<div class="filter-item">
                <label class="filter-label">{{ $t("globals.fieldtracker_task_name") }}</label>
                <b-form-select
                  v-model="filters.fieldtracker_task_name"
                  :options="[{ value: null, text: $t('globals.all') }, ...getFtTasks.map(task => ({ value: task, text: task }))]"
                  class="filter-select"
                  @change="filterChanged"
                  :disabled="getServicesLoading"
                />
              </div>
							
            </div>

					 </div>

					<div class="table-wrapper">
            <table class="modern-table">
							<thead>
								<tr>
									<th
              v-for="field in fields"
              :key="field.key"
              :class="{ sortable: field.sortable, [field.class]: field.class }"
              @click="onSortClick(field)"
            >
              {{ field.label || field.key }}
              <span v-if="sortBy === field.key" class="sort-icon">
                {{ sortDesc ? '▼' : '▲' }}
              </span>
            </th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="service in getServices" :key="service.id"  @click="rowClicked(service)">
									<td>{{ service.id }}</td>
									<td>{{ service.agent.full_name }}</td>
									<td>
                    <router-link
                      v-if="service.customer != null"
                      class="customer-link"
                      :to="{name: 'customer', params:{ id: service.customer.id }}"
                      @click.native.stop
                      target="_blank"
                    >
                      {{ service.customer.company_name }}
                    </router-link>
                    <span v-else>-</span>
                    
                  <td>
                    <router-link
                      v-if="service.order"
                      class="customer-link"
                      :to="{name: 'order', params:{ id: service.order.id }}"
                      @click.native.stop
                      target="_blank"
                    >
                      {{ service.order.order_no }}
                    </router-link>
                    <span v-else>-</span>
                    
									<td>
                    <span class="status-badge" :class="`status-${service.status}`">
                      {{ service.status }}
                    </span>
                  </td>
									<td>{{ service.service_type }}</td>
									<td>{{ service.fieldtracker_task_name }}</td>
									<td>{{ formatDate(service.created_at) }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="pagination-section">
			
      <div class="controls-left">
        <span class="summary-label">
          {{ $t("globals.showing") }} {{ offset + 1 }}-{{ Math.min(offset + perPage, getTotalServices) }}
        </span>
        <select v-model="perPage" class="per-page-select">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="40">40</option>
          <option :value="60">60</option>
        </select>
      </div>
      <div class="pagination-controls">
        <button
          class="page-btn"
          :disabled="offset === 0 || getServicesLoading"
          @click="fetchLess"
        >
          &lt;
        </button>
        <button
          class="page-btn"
          :disabled="getServices.length < perPage || getServicesLoading"
          @click="fetchMore"
        >
          &gt;
        </button>
      </div>
    </div>
	</div>
  
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "vue-awesome/icons/spinner";
import "vue-awesome/icons/sync-alt";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
  },
  data() {
    return {
      filters: {
        order_no: this.$route.query.order_no || null,
				status: this.$route.query.status || null,
				customer_id: parseInt(this.$route.query.customer_id) || null,
				agent_id: parseInt(this.$route.query.agent_id) || null,
				service_type: this.$route.query.service_type || null,
				fieldtracker_task_name: this.$route.query.fieldtracker_task_name || null,
			},
      offset: parseInt(this.$route.query.offset) || 0,
      perPage: parseInt(this.$route.query.perPage) || 20,
      sortBy: this.$route.query.sortBy || "created_at",
      sortDesc: this.$route.query.sortDesc === "true" || true,
      fields: [
        { key: "id", label: "ID", sortable: true },
        { key: "agent", label: "Agent", sortable: true },
        { key: "customer", label: this.$t("globals.customer"), sortable: true },
        { key: "order_no", label: this.$t("globals.order_no"), sortable: true },
        { key: "status", label: this.$t("globals.status"), sortable: false },
        { key: "service_type", label: this.$t("globals.service_type"), sortable: true },
        { key: "fieldtracker_task_name", label: this.$t("globals.fieldtracker_task_name"), sortable: true },
        { key: "created_at", label: this.$t("globals.created_at"), sortable: true },
      ],
      orderNoTimeout: null
			
    };
  },
  
  computed: {
    ...mapGetters("services", [
      "getServices",
      "getServicesLoading",
      "getTotalServices",
			"getStatuses",
			"getAgents",
			"getServiceTypes",
			"getFtTasks",
			"getCustomers",
    ]),
  },
  methods: {
    ...mapActions("services", ["fetchServices"]),
    reloadData(){
      this.offset = 0;
      this.filters.order_no = null;
      this.filters.status = null;
      this.filters.customer_id = null;
      this.filters.agent_id = null;
      this.filters.service_type = null;
      this.filters.fieldtracker_task_name = null;

      this.fetchData();
    },
    fetchData() {
			this.fetchServices({
        limit: this.perPage,
        offset: this.offset,
        order_by: this.sortBy,
        order_direction: this.sortDesc ? "DESC" : "ASC",
				filters: this.filters,
      });
			this.setFiltersInURL();
    },
		onSortClick(field) {
			if (!field.sortable || this.getServicesLoading) return;

			this.handleSort(field.key);
		},

    handleSort(fieldKey) {
			this.offset = 0;
      if (this.sortBy === fieldKey) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = fieldKey;
        this.sortDesc = false;
      }
      this.fetchData();
    },

    fetchMore() {
      this.offset += this.perPage;
      this.fetchData();
    },

    fetchLess() {
      if (this.offset >= this.perPage) {
        this.offset -= this.perPage;
        this.fetchData();
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return "";

      if (dateStr.includes("/")) {
        const [day, month, year] = dateStr.split("/");
        return `${day}-${month}-${year}`;
      }

      const date = new Date(dateStr);
      if (isNaN(date)) return "";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
		resetFilters(){
			this.filters.status = null;
			this.filters.customer = null;
			this.filters.agent = null;
			this.filters.service_type = null;
			this.filters.fieldtracker_task_name = null;
			this.fetchData();
		},
		filterChanged(){
			this.offset = 0;
			this.fetchData();
			
		},
    onInput(){
      const value = this.filters.order_no || '';
      if(value.length == 0){
        this.filterChanged();
        return;
      }
      if (value.length < 3) return;
      clearTimeout(this.orderNoTimeout);
      this.orderNoTimeout = setTimeout(() => { this.filterChanged();}, 500);
    },
		rowClicked(item) {
      // Don't navigate if user is selecting text
      const selection = window.getSelection();
      if (selection && selection.toString().length > 0) {
        return;
      }
      this.setFiltersInURL();
      this.$router.push({ name: "service", params: { id: item.id } });
    },
		setFiltersInURL() {
      this.$router.replace(
				{ 
					query: { 
						perPage: this.perPage, 
						sortBy: this.sortBy, 
						sortDesc: this.sortDesc, 
						offset: this.offset,
            
            order_no: this.filters.order_no,
						status: this.filters.status,
						customer_id: this.filters.customer_id,
						agent_id: this.filters.agent_id,
						service_type: this.filters.service_type,
						fieldtracker_task_name: this.filters.fieldtracker_task_name,
					}
				}).catch(() => {});
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    perPage() {
      this.offset = 0; // reset offset when perPage changes
      this.fetchData();
    },
  },
  
};
</script>


